import ONGP1 from "../../interfaces/finishedProgress";
import { useEffect, useState, useContext, useCallback } from "react"
import MktProgressTable from "./mktProgress";
import { AuthContext } from "../../context/auth";

export default function UserRow(){
    
    const [ONGP1List, setONGP1List] = useState<ONGP1[]>([]);
    const userContext = useContext(AuthContext);
    const [showResult, setResult] = useState<boolean>(false);

    const sendOne = useCallback(() => {
        let token: string = "";

        if (localStorage.getItem("USER_TOKEN") !== null) {
            token = localStorage.getItem("USER_TOKEN")!;
        }

        fetch(`${userContext?.api_url}/user/getFinishedMKTAll`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': token
            }
        }).then(resp => {
            if (resp.status >= 400) {
                console.log(resp);
                setResult(false);
            } else {
                resp.json().then(jsonResponse => {
                    console.log("API Response:", jsonResponse); // Debug log
                    
                    if(jsonResponse.status === "OK" && jsonResponse.info && jsonResponse.info.length > 0) {
                        setONGP1List(jsonResponse.info);
                        setResult(true);
                        console.log("Data set:", jsonResponse.info); // Debug log
                    } else {
                        console.log("No data or empty array in response");
                        setResult(false);
                    }
                });
            }
        }).catch((err) => {
            console.log("Error fetching data:", err);
            setResult(false);
        });
    }, [userContext?.api_url]);

    useEffect(() => {
        sendOne();
    }, [sendOne]);

    return(
        <div className="justify-center items-center content-center flex overflow-x-hidden overflow-y-auto inset-0 z-50 outline-none focus:outline-none bg-principal-3 p-4">
            {showResult ? (
                // Pass the entire array directly to the table component
                <MktProgressTable ongP1List={ONGP1List} />
            ) : (
                <div className="flex w-full text-3xl font-semibold text-principal-2 items-center justify-center h-screen">
                    <h1>Aún no se ha llenado ningún cuestionario.</h1>
                </div>
            )}
        </div>
    );
}